export default __webpack_public_path__ + "static/media/promoVideo.7093db18.mp4";